import { DashboardData } from 'mobx/storeTypes';
import { forEach, isEmpty, map, pick, toPairs } from 'lodash-es';
import {
  ColumnChartParams,
  ColumnChartSeriesType,
} from 'components/columnChart/columnChartTypes';
import {
  addDataLabelsToChartSeries,
  addPlotBands,
  getEmptyColumnChartData,
} from 'utils/dataAdapters/chartAdapters';
import { formatDate } from 'utils/dateFormat';
import { getDateColor } from 'utils/dataMappings';
import _ from 'lodash';
import { SimpleSeries } from 'components/multipleLineChart/types';

type EmployeePreparedItem = {
  color: string;
  by_coworkers: number | null;
  by_lead: number | null;
  by_subordinates: number | null;
  name: string;
  start_date: string;
  y: number | null;
};

export const getEmployeeInfoDataAdapted = (
  data: DashboardData.EmployeeInfo
) => {
  if (isEmpty(data)) {
    return getEmptyColumnChartData();
  }

  const prerapedMap: Record<string, EmployeePreparedItem[]> = {};

  const statistics = data.statistics;

  forEach(statistics, (statisticsItem) => {
    const start_date = formatDate(statisticsItem.start_date);

    const item = {
      ...pick(statisticsItem, ['by_coworkers', 'by_lead', 'by_subordinates']),
      y: statisticsItem.value,
      color: getDateColor(start_date),
      start_date,
      name: 'Средняя оценка',
    };

    if (start_date in prerapedMap) {
      prerapedMap[start_date].push(item);
    } else {
      prerapedMap[start_date] = [];
      prerapedMap[start_date].push(item);
    }
  });

  const entriesFromMap = toPairs(prerapedMap);
  const preparedData: Array<ColumnChartSeriesType> = map(
    entriesFromMap,
    ([label, dataItems]) => {
      const newItem = {
        name: label,
        dataLabels: addDataLabelsToChartSeries(),
        data: dataItems,
      };

      return newItem;
    }
  );

  const xAxisCategories = [data.employee_name];

  return {
    series: preparedData,
    axisParams: {
      xAxisCategories,
      plotBands: addPlotBands(xAxisCategories),
    },
  } as ColumnChartParams;
};

export const employeeColors = {
  by_coworkers: '#B675FF',
  by_lead: '#FFFFFF',
  by_subordinates: '#0CC0A2',
  avg: 'orange',
};

const getAvg = (data: any) => {
  const avg =
    ((data?.[0]?.['by_coworkers'] || 0) +
      (data?.[0]?.['by_lead'] || 0) +
      (data?.[0]?.['by_subordinates'] || 0)) /
    _.filter(
      [
        data?.[0]?.['by_coworkers'],
        data?.[0]?.['by_lead'],
        data?.[0]?.['by_subordinates'],
      ],
      (item) => !!item
    )?.length;

  return Math.round(avg * 100) / 100;
};

export const adaptColumnChartDataToLineChartData = (
  data: ColumnChartParams
) => {
  const seriesNames = ['by_coworkers', 'by_lead', 'by_subordinates', 'avg'];

  const series = seriesNames.map((name) => ({
    name,
    data: _.map(
      data?.series,
      // @ts-ignore
      ({ name: period, data }) => ({
        y: name !== 'avg' ? data?.[0]?.[name] : getAvg(data),
        name: period,
        custom: {
          by_coworkers: data?.[0]?.['by_coworkers'],
          by_lead: data?.[0]?.['by_lead'],
          by_subordinates: data?.[0]?.['by_subordinates'],
          avg: getAvg(data),
        },
      })
    ),
    // @ts-ignore
    color: employeeColors?.[name],
  })) as SimpleSeries[];

  return _.filter(series, (s) => _.some(s.data, (item) => item.y));
};
